// @flow

import React from "react";
import { Flex } from "@chakra-ui/react";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";

import * as styles from "../styles";
import SortableItem from "./SortableItem";
import AddComparisonDropdown from "./AddComparisonDropdown";

type Props = {
  itemIds: string[],
  chartDetails: Object,
  setChartDetails: Function,
};

function SortableList({ itemIds, chartDetails, setChartDetails }: Props) {
  return (
    <SortableContext items={itemIds} strategy={verticalListSortingStrategy}>
      <Flex sx={styles.SortableItemWrapper}>
        {
          // $FlowFixMe  - Flow does not yet support method or property calls in optional chains
          chartDetails.series?.map((chart, index) => {
            const { seriesId, tempId, plotType } = chart;
            return (
              <SortableItem
                key={seriesId || tempId}
                id={seriesId || tempId}
                chartDetails={chartDetails}
                plotType={plotType}
                position={index + 1}
                setChartDetails={setChartDetails}
              />
            );
          })
        }

        <AddComparisonDropdown setChartDetails={setChartDetails} />
      </Flex>
    </SortableContext>
  );
}

export default SortableList;
